import React from "react";

import { MenuItem, TextField } from "@mui/material";

import { CATEGORIES, MAX_METADATA_LENGTH } from "@/util/constants";
import { FileData } from "@/util/interfaces/FileData";

interface ISelectMetadataFormProps {
  internalFiles: FileData[];
  fileCategoryValue: string;
  setInternalFiles: React.Dispatch<React.SetStateAction<FileData[]>>;
  metadataValue: string;
}

export const SelectMetadataForm: React.FC<ISelectMetadataFormProps> = ({
  internalFiles,
  fileCategoryValue,
  setInternalFiles,
  metadataValue,
}) => {
  return (
    <div className="form-details flex flow-column">
      <span className="title" style={{ fontSize: "16px" }}>
        Details
      </span>
      <div className="flex space-between">
        <span style={{ fontSize: "14px", marginTop: "10px" }}>Provide the file details.</span>
        <span>
          <span style={{ color: "red" }}>*</span>Indicates required
        </span>
      </div>
      <div className="flex flow-column" style={{ marginTop: "20px", rowGap: "20px" }}>
        <div className="flex flow-column">
          <span>
            <span style={{ color: "red" }}>*</span>File category
          </span>
          <TextField
            color="success"
            select
            label="Select"
            name="fileCategory"
            disabled={internalFiles.filter((iF) => iF.isChecked).length === 0}
            value={fileCategoryValue}
            onChange={(e) => {
              setInternalFiles((prev) =>
                prev.map((f) =>
                  f.isChecked ? { ...f, fileCategory: e.target.value, isCompleted: true } : f
                )
              );
            }}
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            inputProps={{ "data-testid": "categorySelector" }}
          >
            {CATEGORIES.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className="flex flow-column">
          <span>Metadata</span>
          <TextField
            color="success"
            label="Type"
            name="metadata"
            disabled={internalFiles.filter((iF) => iF.isChecked).length === 0}
            value={metadataValue}
            onChange={(e) => {
              if (e.target.value.length <= MAX_METADATA_LENGTH) {
                setInternalFiles((prev) =>
                  prev.map((f) => (f.isChecked ? { ...f, metadata: e.target.value } : f))
                );
              }
            }}
            fullWidth
            multiline
            rows={4}
            margin="normal"
            variant="outlined"
            inputProps={{ "data-testid": "metadataField" }}
            placeholder="Metadata improves AI search by adding context with keywords and descriptions, making search results more relevant and responses better."
          />
          <div className="text_counter_container">
            {metadataValue?.length} / {MAX_METADATA_LENGTH}
          </div>
        </div>
      </div>
    </div>
  );
};
